export default __webpack_public_path__ + "static/media/lawn.c88a4d3b.png";